import React, { useEffect } from "react";
import {
  useNotify,
  useTranslate,
  useRedirect, Notification,
} from "react-admin";
import { Form } from "react-final-form";
import {
  Button,
  Card,
  CardActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CustomFooter from "./custom/layout/CustomFooter";
import dataIntermediaryProvider from "../synapse/intermediaryDataProvider";
import authService from '../auth.js';
//import loadAmpel from "../mixins/matrix_ampel.js";
export const saveUserIdInLocalStorage = (oidcItem) => {
  const json = JSON.parse(oidcItem);
  localStorage.setItem("userId", json?.profile?.bycsId);
};

export const getOidcItem = () => {
  let oidcItem;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes("oidc")) {
      oidcItem = localStorage.getItem(key);
      break;
    }
  }
  return oidcItem
}

const useStyles = makeStyles(theme => ({
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 1em)",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "#264D7F",
  },
  trafficLight: {
    position: "absolute",
    transform: "translate(300px, 100px)",
  },
  card: {
    minWidth: "30em",
    marginTop: "6em",
    marginBottom: "6em",
  },
  hint: {
    marginTop: "1em",
    display: "flex",
    justifyContent: "center",
    color: theme.palette.grey[500],
    fontFamily: theme.typography.fontFamily,
  },
  form: {
    padding: "0 1em 1em 1em",
  },
  input: {
    marginTop: "2em",
  },
  actions: {
    padding: "0 1em 1em 1em",
  },
  serverVersion: {
    color: "#9e9e9e",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    marginBottom: "1em",
    marginLeft: "0.5em",
  },
  logo: {
    objectFit: "contain",
    width: "84px",
    height: "84px",
    padding: "8px",
    margin: "16px 0 0 0",
  },
  centered: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  btnWrapper: {
    marginTop: "2rem",
    width: "100%",
  },
  ssoBtn: {
    backgroundColor: "#264D7F",
    color: "white",
  },
}));

export const getToken = () => {
  let oidcItem = null;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes("oidc")) {
      oidcItem = localStorage.getItem(key);
      break;
    }
  }
  if (oidcItem) {
    const json = JSON.parse(oidcItem);
    return json.access_token;
  }
}


const LoginPage = ({ theme }) => {
  const classes = useStyles({ theme });
  const notify = useNotify();
  const translate = useTranslate();
  const ssoBaseUrl = window.ENV.intermediary_endpoint
  const code = +localStorage.getItem('auth_code')
  const isLoggedIn = localStorage.getItem('isLoggedIn')
  const redirect = useRedirect()
  const errorCodes = {
    401: translate("synapseadmin.auth.log_again"),
    403: translate("synapseadmin.auth.not_admin"),
    404: translate("synapseadmin.auth.not_found"),
  };
  code && notify(errorCodes[code], "warning");


  let oidcItem = null;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes("oidc")) {
      oidcItem = localStorage.getItem(key);
      break;
    }
  }
  if (oidcItem) {

    authService.signinRedirectCallback().then(() => {
      const token = getToken()
      if (token) {
        //
        localStorage.setItem('isLoggedIn', true);
      }
      //
      if (localStorage.getItem('isLoggedIn')) {
        const oidcItemee = getOidcItem()
        //
        if (oidcItemee) {
          saveUserIdInLocalStorage(oidcItemee)
          window.history.replaceState(null, null, window.location.origin + '/login');
          redirect("/users");
        }
      }



    })
  }

  const handleSubmit = auth => {
    auth.preventDefault()
  };


  const oidcLogin = async () => {
    authService.login()
  }

  return (
    <>
      <Form
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <div className={classes.main}>
              <div className={classes.trafficLight} />
              <Card className={classes.card}>
                <div className={classes.centered}>
                  <img src={process.env.REACT_APP_BYCS_LOGO} className={classes.logo} alt="logo" />
                </div>
                <div className={classes.hint}>
                  {translate("synapseadmin.auth.welcome")}
                </div>

                <CardActions className={classes.actions}>
                  <div className={classes.btnWrapper}>
                    <Button
                      variant="contained"
                      onClick={oidcLogin}
                      className={classes.ssoBtn}
                      fullWidth
                    >
                      {translate("synapseadmin.auth.sso_sign_in")}
                    </Button>
                  </div>
                </CardActions>
              </Card>
            </div>
          </form>
        )}
        onSubmit={handleSubmit}
      />
      <CustomFooter />
      <Notification />
    </>
  );
};

export default LoginPage;
